import React from "react";
import _pubDf2A042 from "./Field.pc";
import _pub5Ab99334 from "./TextInput.pc";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "./utils.pc";
import _pub2Dbb4493 from "./Button.pc";
import _pub824B8933, {FormLayout as _pub824B8933_FormLayout} from "./layout.pc";
import "./Form.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement(_pub824B8933_FormLayout, {
    "class": "_9c35f837 _f10efa37 _pub-f10efa37" + (props["class"] ? " " + props["class"] : "") + " " + " " + (props["className"] ? " " + props["className"] : ""),
    "ref": ref,
    "testId": props["testId"],
    "onSubmit": props["onSubmit"],
  }, 
    props["children"]
  )
}));
export default $$Default;

var Row = React.memo(React.forwardRef(function Row(props, ref) {
  return React.createElement("div", {
    "className": "_7b8dd530 _f10efa37 _pub-f10efa37" + (props["class"] ? " " + props["class"] : "") + " " + " " + (props["className"] ? " " + props["className"] : "") + (props["v3"] ? " " + "_f10efa37_v3 _pub-f10efa37_v3 v3" : ""),
    "ref": ref,
  }, 
    props["children"]
  )
}));
export { Row };


